import React, { useState, useEffect } from 'react';
import axios from 'axios';

const URLDisplay = () => {
  const [url, setUrl] = useState('');
  const [savedUrl, setSavedUrl] = useState('');
  const [role, setRole] = useState('');

  // Load role and URL from server on component mount
  useEffect(() => {
    const fetchUserRoleAndUrl = async () => {
      try {
        // Fetch role from stored user data
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && user.role) {
          setRole(user.role);
        } else {
          const response = await axios.get(
            'https://cmti-edge.online/foundry/php/auth.php',
            { params: { action: 'getRole' }, withCredentials: true }
          );
          setRole(response.data.role || '');
        }

        // Fetch the saved URL from the backend
        const urlResponse = await axios.get(
          'https://cmti-edge.online/foundry/php/urlHandler.php'
        );
        console.log("URL Response:", urlResponse.data); // Log the URL response
        setSavedUrl(urlResponse.data.url); // Ensure it's setting correctly
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserRoleAndUrl();
  }, []);


  // Handle URL input change
  const handleChange = (e) => {
    setUrl(e.target.value);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!url.trim()) return;

    if (role === 'MANAGER' || role === 'SUPERVISOR') {
      try {
        // Send the URL to the backend to save
        const response = await axios.post(
          'https://cmti-edge.online/foundry/php/urlHandler.php',
          { url, role }
        );

        if (response.data.success) {
          setSavedUrl(url); // Update the state with the new URL
          setUrl(''); // Clear input field
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        console.error('Error saving URL:', error);
      }
    } else {
      alert('Only MANAGER and SUPERVISOR can submit URLs.');
    }
  };

  // Handle copying URL to clipboard
  const handleCopy = () => {
    navigator.clipboard.writeText(savedUrl).then(() => {
      alert('URL copied to clipboard!');
    });
  };

  return (
    <div className="container mx-auto p-2  bg-gray-800 shadow-lg rounded-lg  items-center space-y-2 w-full ">
      <h1 className="text-lg sm:text-xl lg:text-xl flex justify-center font-bold text-white">
        Welcome, <span className="text-blue-600 ml-2" >{role}</span>
      </h1>
      <div className="flex flex-col md:flex-row md:space-x-1 justify-center items-center w-full space-y-4 md:space-y-0">
        {(role === 'MANAGER' || role === 'SUPERVISOR') && (
          <form onSubmit={handleSubmit} className="flex items-center justify-center w-full md:w-auto">
            <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-3 w-full">
              <input
                type="text"
                value={url}
                onChange={handleChange}
                placeholder="Enter URL"
                className="border-2 border-gray-300 p-2 md:p-3 rounded-md outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition duration-300 ease-in-out w-full md:w-80 lg:w-60"
              />
              <button
                type="submit"
                className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold rounded-md py-2 px-4 md:px-6 hover:shadow-lg transition duration-300 transform hover:-translate-y-0.5"
              >
                Submit
              </button>
            </div>
          </form>
        )}

        {savedUrl && (
          <div className="flex items-center justify-center w-full md:w-auto space-x-1 p-2">
            <div className="flex items-center flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-3 w-full">
              <span className="border-2 border-gray-300 p-2 md:p-3 rounded-md text-gray-700 bg-white truncate w-full md:w-24 lg:w-52 xl:w-52">
                {savedUrl}
              </span>
              <button
                onClick={handleCopy}
                className="bg-gradient-to-r from-green-400 to-emerald-500 text-white font-semibold py-2 px-4 md:px-6 rounded-md hover:shadow-xl transition duration-300 transform hover:-translate-y-0.5 hover:scale-105"
              >
                Copy
              </button>
            </div>
          </div>
        )}
      </div>


    </div>
  );
};

export default URLDisplay;
